import React, { createContext, useState, useEffect, useCallback, useMemo } from 'react';
import { useContext } from 'react';
import { getProfileData, getMyNotifications } from '../api/Api';
import { AuthContext } from './AuthContext';

export const ProfileContext = createContext({});

export const ProfileProvider = ({ children }) => {
  const [profile, setProfile] = useState(null);
  const [notifications, setNotifications] = useState([]);
  const [isLoadingProfile, setIsLoadingProfile] = useState(true); // ← AGREGAR ESTO
  const { userToken } = useContext(AuthContext);

  useEffect(() => {
    console.log('👤 ProfileContext - montado');
    return () => {
      console.log('👤 ProfileContext - desmontado');
    };
  }, []);

  const fetchNotifications = useCallback(async () => {
    if (profile?.is_admin) return;
    try {
      const response = await getMyNotifications();
      setNotifications(response);
    } catch (error) {
      console.error('Error fetching notifications:', error);
    }
  }, [profile?.is_admin]);

  const fetchProfileData = useCallback(async () => {
    if (!userToken) {
      setIsLoadingProfile(false); // ← AGREGAR ESTO
      return;
    }
    setIsLoadingProfile(true); // ← AGREGAR ESTO
    try {
      const response = await getProfileData();
      setProfile(response.json);
    } catch (error) {
      console.error('Error fetching profile:', error);
    } finally {
      setIsLoadingProfile(false); // ← AGREGAR ESTO
    }
  }, [userToken]);

  useEffect(() => {
    fetchProfileData();
  }, [fetchProfileData]);

  useEffect(() => {
    if (profile) {
      fetchNotifications();
    }
  }, [fetchNotifications, profile]);

  // ← AGREGAR isLoadingProfile al value
  const value = useMemo(() => ({
    profile,
    notifications,
    fetchNotifications,
    fetchProfileData,
    isLoadingProfile, // ← AGREGAR ESTO
  }), [profile, notifications, fetchNotifications, fetchProfileData, isLoadingProfile]);

  return (
    <ProfileContext.Provider value={value}>
      {children}
    </ProfileContext.Provider>
  );
};